import {KeyLabel} from './key-label.model';
export enum ActivityStatus {

  DRAFT = 'DRAFT',
  READY = 'READY',
  READY_PENDING_APPROVAL = 'READY_PENDING_APPROVAL',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',

  LIVE = 'LIVE',
  TESTING = 'TESTING',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  STOPPED = 'STOPPED'

}

export const ActivityStatusLabels = {
  DRAFT: 'Draft',
  READY: 'Ready',
  READY_PENDING_APPROVAL: 'Ready (pending approval)',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
  ARCHIVED: 'Archived',
};

export const ActivityStatusTypeLabelKLAddUnits = () => {
  return (Object.keys(ActivityStatusLabels).filter(key => key !== 'READY_PENDING_APPROVAL')).map(key => new KeyLabel(key, ActivityStatusLabels[key]));
};

export const ActivityStatusTypeLabelKLActiveInactive = () => {
  return [
           new KeyLabel(ActivityStatus.ACTIVE, ActivityStatusLabels[ActivityStatus.ACTIVE]),
           new KeyLabel(ActivityStatus.INACTIVE, ActivityStatusLabels[ActivityStatus.INACTIVE])
        ];
};

export const ActivityStatusTypeLabelKL = () =>
  (Object.keys(ActivityStatusLabels).map(key => new KeyLabel<ActivityStatus>(<ActivityStatus>key, ActivityStatusLabels[key])));

export const ActivityStatusTypeLabelKLPublisher = () =>
  ActivityStatusTypeLabelKL().filter(s => [ActivityStatus.ACTIVE, ActivityStatus.INACTIVE].includes(s.key));

export const ActivityStatusTypeLabelKLDomain = () =>
  ActivityStatusTypeLabelKL().filter(s => [ActivityStatus.ACTIVE, ActivityStatus.INACTIVE].includes(s.key));

  export const ActivityStatusTypeLabelKLDemandPartner = () =>
  ActivityStatusTypeLabelKL().filter(s => [ActivityStatus.ACTIVE, ActivityStatus.INACTIVE].includes(s.key));
